<template>
  <div :class="`text-caps text-sparse-1 text-nowrap ${colorize ? 'color-brand_main' : ''}`">
    <!--  -->
    Hobson Bernardino
  </div>
</template>

<script setup>
defineProps({ colorize: { type: Boolean } });
</script>
